__webpack_require__.p = "/js/blesk-tv/dist/";